/**
 * @generated SignedSource<<bbc5a8c1716bdc27e03c102969870a87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarousel_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselRequestMore_user" | "ViewInRoom_user">;
  readonly " $fragmentType": "PdpRespHeroCarousel_user";
};
export type PdpRespHeroCarousel_user$key = {
  readonly " $data"?: PdpRespHeroCarousel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespHeroCarousel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarousel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoom_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeroCarouselRequestMore_user"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "df6ff2d70f3ef13591addf10a638ecf9";

export default node;
